import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function NotFound404() {
  const themeColor = 'rgba(244, 147, 0, 1)'; // currentnav

  return (
    <div className="min-h-screen bg-white flex flex-col justify-center items-center px-4 py-12 font-sans">
      {/* Animated 404 Image */}
      <motion.div
        className="w-full max-w-2xl h-[300px] sm:h-[400px] bg-center bg-no-repeat bg-contain"
        style={{
          backgroundImage:
            'url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif)',
        }}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
      />

      {/* Main 404 Title */}
      <motion.h1
        className="text-[80px] font-bold text-gray-800 text-center"
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        404
      </motion.h1>

      {/* Subtext and Button */}
      <motion.div
        className="text-center mt-[-30px]"
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5 }}
      >
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-700">
          Looks like you're lost
        </h2>
        <p className="text-md text-gray-500 mt-2">
          The page you are looking for is not available!
        </p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-2 rounded text-white font-semibold transition duration-300 hover:scale-105"
          style={{ backgroundColor: themeColor }}
        >
          Go to Home
        </Link>
      </motion.div>
    </div>
  );
}
